// Every date the app shows goes through here, so they all look the same:
//   formatDate         1 Nov 2026
//   formatDayDate      Sat 1 Nov 2026     (where the day of the week matters)
//   formatMonth        Nov 2026
//   formatDateTime     1 Nov 2026, 14:05
//   formatTime         14:05
//   formatChatDay      Today, Yesterday, Saturday (this past week), then 1 Nov 2026
// Always UK time, whatever the phone's language or time zone, and always three
// letter months (the browser's en-GB gives "Sept").
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const LONG_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const parts = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

// A "2026-11" month is the 1st of that month; a Date or ISO string as it is
function toDate(value) {
  if (value === null || value === undefined || value === '') return new Date(NaN);
  if (value instanceof Date) return value;
  if (typeof value === 'string' && /^\d{4}-\d{2}$/.test(value)) return new Date(`${value}-01T12:00:00Z`);
  return new Date(value);
}

// The date in the UK: { year, month (0-11), day, weekday (0-6), hour, minute }
function uk(value) {
  const d = toDate(value);
  if (Number.isNaN(d.getTime())) return null;
  const p = Object.fromEntries(parts.formatToParts(d).map(x => [x.type, x.value]));
  const year = +p.year;
  const month = +p.month - 1;
  const day = +p.day;
  return { year, month, day, weekday: new Date(Date.UTC(year, month, day)).getUTCDay(), hour: p.hour, minute: p.minute };
}

export function formatDate(value) {
  const d = uk(value);
  return d ? `${d.day} ${MONTHS[d.month]} ${d.year}` : '';
}

export function formatDayDate(value) {
  const d = uk(value);
  return d ? `${DAYS[d.weekday]} ${d.day} ${MONTHS[d.month]} ${d.year}` : '';
}

export function formatMonth(value) {
  const d = uk(value);
  return d ? `${MONTHS[d.month]} ${d.year}` : '';
}

export function formatTime(value) {
  const d = uk(value);
  return d ? `${d.hour}:${d.minute}` : '';
}

export function formatDateTime(value) {
  const d = uk(value);
  return d ? `${formatDate(value)}, ${d.hour}:${d.minute}` : '';
}

// Whole days from `then` to `now`, by the UK calendar
function daysBetween(then, now) {
  return Math.round((Date.UTC(now.year, now.month, now.day) - Date.UTC(then.year, then.month, then.day)) / 86400000);
}

export function formatChatDay(value, now = new Date()) {
  const d = uk(value);
  const today = uk(now);
  if (!d || !today) return '';
  const ago = daysBetween(d, today);
  if (ago === 0) return 'Today';
  if (ago === 1) return 'Yesterday';
  if (ago > 1 && ago < 7) return LONG_DAYS[d.weekday];
  return formatDate(value);
}
